import { createRouter, createWebHistory, type RouteRecordRaw, type RouteLocationNormalized, type NavigationGuardNext } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Lottery',
    component: () => import('@/views/LotteryView.vue'),
    meta: { title: '大腸鏡研究案抽籤系統' }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/AdminView.vue'),
    meta: { title: '管理中心 - 研究案抽籤系統', requiresAuth: true }
  },
  {
    path: '/record/:id',
    name: 'RecordDetail',
    component: () => import('@/views/RecordDetailView.vue'),
    meta: { title: '紀錄詳情 - 研究案抽籤系統', requiresAuth: true }
  },
  // 族譜管理路由 - 重導向到管理中心
  {
    path: '/pedigree',
    name: 'PedigreeList',
    redirect: { path: '/admin', query: { tab: 'pedigrees' } },
    meta: { title: '族譜管理 - 研究案抽籤系統', requiresAuth: true }
  },
  {
    path: '/pedigree/new',
    name: 'PedigreeNew',
    component: () => import('@/views/PedigreeEditor.vue'),
    meta: { title: '新建族譜 - 研究案抽籤系統', requiresAuth: true }
  },
  {
    path: '/pedigree/:id',
    name: 'PedigreeEdit',
    component: () => import('@/views/PedigreeEditor.vue'),
    meta: { title: '編輯族譜 - 研究案抽籤系統', requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守衛
router.beforeEach(async (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  // 設定頁面標題
  document.title = (to.meta.title as string) || '大腸鏡研究案抽籤系統'

  const authStore = useAuthStore()

  // 檢查是否需要認證
  if (to.meta.requiresAuth || to.meta.requiresAdmin) {
    if (!authStore.accessToken) {
      return next('/')
    }

    // 如果有 token 但沒有使用者資訊，嘗試驗證
    if (!authStore.currentUser) {
      try {
        const { authService } = await import('@/services/authService')
        const me = await authService.getMe()
        if (me.success && me.username) {
          authStore.setUserInfo(me.username, me.name || '')
          // 如果是需要 Admin 權限的路由，額外檢查
          if (to.meta.requiresAdmin && me.username !== 'admin') {
            return next('/')
          }
          return next()
        } else {
          authStore.clearAuth()
          return next('/')
        }
      } catch {
        authStore.clearAuth()
        return next('/')
      }
    }

    // 已有使用者資訊，檢查 Admin 權限
    if (to.meta.requiresAdmin && authStore.currentUser !== 'admin') {
      return next('/')
    }
  }

  next()
})

export default router
